export const auctionItemsListStyle = {
	wrapperList: {
		position: 'relative',
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '100%',
		boxShadow: 'var(--box-shadow--2)',
		flexGrow: '1',
		'@media (max-width: 639.98px)': {
			paddingX: '0px',
		},
	},

	lotList: {
		display: 'grid',
		gridTemplateColumns: 'repeat(4, 1fr)',
		gap: '16px',
		flexGrow: '1',
		marginBottom: '20px',

		'@media (max-width: 1023.98px)': {
			gridTemplateColumns: 'repeat(3, 1fr)',
		},

		'@media (max-width: 959.98px)': {
			gridTemplateColumns: 'repeat(2, 1fr)',
			gap: '12px',
		},

		'@media (max-width: 425px)': {
			gridTemplateColumns: '1fr',
			gap: '12px',
		},

		'@media (max-width: 639.98px)': {
			paddingX: '20px',
		},
		// display: 'grid',
		// gridTemplateColumns: 'repeat(4, 1fr)',
		// gap: '16px',
		// marginBottom: '10px',
		// position: 'relative',
		// flexGrow: '1',
	},

	pagination: {
		marginLeft: 'auto',

		'@media (max-width: 639.98px)': {
			margin: '0px auto',
		},
	},
};
